import { HttpService } from "../../modules/shared/services/http.service";
import { 
  AdminSecurities, 
  AdminSecuritiesCreateDto, 
  AdminSecuritiesUpdateDto,
  AdminSecuritiesResponse,
  AdminSecuritiesLatestResponse
} from "../../modules/shared/model";

const headers = { "Content-Type": "application/json", "x-custom-lang": "en" } as const;

// Get latest admin securities
export const getLatestAdminSecurities = async (): Promise<AdminSecuritiesLatestResponse> => {
  const response = await HttpService.get("api/v1/admin-securities/latest", true, { "x-custom-lang": "en" });
  return response;
};

// Get all admin securities with pagination
export const getAdminSecurities = async (query?: Record<string, string | number | boolean>): Promise<AdminSecuritiesResponse> => {
  const qs = new URLSearchParams();
  Object.entries(query || {}).forEach(([k, v]) => {
    if (v !== undefined && v !== null) qs.append(k, String(v));
  });
  const response = await HttpService.get(`api/v1/admin-securities${qs.toString() ? `?${qs}` : ""}`, true, { "x-custom-lang": "en" });
  return response;
};

// Get admin securities by ID
export const getAdminSecuritiesById = async (id: string): Promise<AdminSecurities> => {
  const response = await HttpService.get(`api/v1/admin-securities/${id}`, true, { "x-custom-lang": "en" });
  return response;
};

// Create new admin securities
export const createAdminSecuritiesAction = async (data: AdminSecuritiesCreateDto): Promise<AdminSecurities> => {
  const response = await HttpService.post("api/v1/admin-securities", data, headers, true);
  return response;
};

// Update admin securities
export const updateAdminSecuritiesAction = async (id: string, data: AdminSecuritiesUpdateDto): Promise<AdminSecurities> => {
  const response = await HttpService.patch(`api/v1/admin-securities/${id}`, data, headers, true);
  return response;
};

// Delete admin securities
export const deleteAdminSecuritiesAction = async (id: string): Promise<void> => {
  await HttpService.deleteRecord(`api/v1/admin-securities/${id}`, { "x-custom-lang": "en" }, true);
};
